export const GET_METATX_ENABLED = 'parcel/metatx/GET_METATX_ENABLED';
export const GET_METATX_ENABLED_SUCCESS =
  'parcel/metatx/GET_METATX_ENABLED_SUCCESS';
export const GET_METATX_ENABLED_ERROR =
  'parcel/metatx/GET_METATX_ENABLED_ERROR';
